import React from 'react';
import Timeline from 'components/timelines/1965-present/Timeline1965ToPresent.js';

const C7S15 = ({position}) => <Timeline progress={position}/>;

export default C7S15;
